module.exports = __webpack_public_path__ + "static/media/xiaochengx.68131d95.png";